import { Modal } from 'react-bootstrap';
import { Button, Label } from '../../atoms';
import styles from './AddOrganizationLandscapeModal.module.css';
import { FC } from 'react';
import { CustomDropdown } from '../../molecules';
import { LandscapeResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-response.dto';
import { LandscapeSupportersSaveRequestDto } from '../../../store/tradeAPI/commodity/dto/request/landscape-suporters-save-request.dto';

interface AddOrganizationLandscapeModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  landscapes: LandscapeResponseDto[];
  landscapeSupporter: LandscapeSupportersSaveRequestDto;
  handleOnChange: (
    landscapeSupporter: LandscapeSupportersSaveRequestDto
  ) => void;
  callbackFn: (landscapeSupporter: LandscapeSupportersSaveRequestDto) => void;
}

const AddOrganizationLandscapeModal: FC<AddOrganizationLandscapeModalProps> = ({
  show,
  setShow,
  landscapes,
  landscapeSupporter,
  handleOnChange,
  callbackFn,
}) => {
  const landscapeItems = landscapes.map((item) => ({
    eventKey: item.id,
    label: item.name,
  }));

  return (
    <Modal centered show={show} onHide={() => setShow(false)}>
      <div className={styles.modal}>
        <Modal.Body className={styles.modalBody}>
          <Label content="Add Landscape" className={styles.title} />
          <div className={styles.modalInput}>
            <label>Landscape</label>
            <CustomDropdown
              initialTitle="Please select a Landscape"
              items={landscapeItems}
              onSelectOption={(e) => {
                handleOnChange({
                  ...landscapeSupporter,
                  compactId: e.eventKey,
                });
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalButtons}>
          <Button
            onClick={() => callbackFn(landscapeSupporter)}
            className={styles.buttonBorder}
            variant="light"
          >
            Save
          </Button>
          <Button
            className={styles.buttonBorder}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default AddOrganizationLandscapeModal;
